import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types.d';

interface UseImageHandlingChecksParams {
  images: ImageDocumentStoreItem[];
}

export const useImageHandlingChecks = ({ images }: UseImageHandlingChecksParams) => {
  const isSingleImage = images.length === 1;

  return { isSingleImage };
};
